import { zodResolver } from "@hookform/resolvers/zod"
import { useForm } from "react-hook-form"
import { toast } from "@/hooks/use-toast"
import { usePersonCustom } from "@/services/queries/usePerson"
import { personPersonalizationSchema } from "../schemas/person-personalization-schema"
import type { PersonPersonalizationFormData } from "../types/person-personalization"
import { transformPersonalizationToCustom } from "../utils/person-transformers"

interface UsePersonPersonalizationProps {
  onSuccess: () => Promise<void> | void
}

export function usePersonPersonalization({ onSuccess }: UsePersonPersonalizationProps) {
  const form = useForm<PersonPersonalizationFormData>({
    resolver: zodResolver(personPersonalizationSchema),
    defaultValues: {
      userName: "",
      userDescription: "",
      userProfileImage: "",
      companyName: "",
      companyDescription: "",
      companyProfileImage: "",
      userFacebookUrl: "",
      userTwitterUrl: "",
      userLinkedinUrl: "",
      userInstagramUrl: "",
      companyFacebookUrl: "",
      companyTwitterUrl: "",
      companyLinkedinUrl: "",
      companyInstagramUrl: "",
    },
  })

  const { mutateAsync: updateCustom, isPending } = usePersonCustom(false)

  const onFormSubmit = async (data: PersonPersonalizationFormData) => {
    try {
      await updateCustom(transformPersonalizationToCustom(data, false))
      await updateCustom(transformPersonalizationToCustom(data, true))

      toast({
        title: "Personalização salva",
        variant: "success",
      })
      onSuccess ? await onSuccess() : null
    } catch (error) {
      console.error("Erro ao salvar personalização:", error)
      toast({
        title: "Erro ao salvar personalização",
        description: "Não foi possível salvar seus dados.",
        variant: "destructive",
      })
    }
  }

  return {
    form,
    isPending,
    onFormSubmit,
  }
}
